// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yfuP","label":"styles_label__3rVQu"};